/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CommonMultiSelect from '../../../Components/Utility/FilterAction/CommonMultiSelect';
import '../SystemMasters.css';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

export default function DropdownCard({
  item,
  index,
  handleChanged,
  addValueForLabel,
  activeInactiveClicked,
  handleDelete,
  handleValueChanged,
  openList,
  setOpenList,
  masterAddEditAccess,
  masterDeleteAccess,
  onDropSelectionChange,
  isUniqueId,
  uniqueValueId,
}) {
  const { t } = useTranslation('common');

  const { CheckActionPermission, createConditionalComponent } = useComponent();
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
    SystemMastersDetails: { pcTypeList },
  } = reducer;

  const MasterAddEditWrapper = createConditionalComponent(logInRights, 'masters', 'customAttribute', 'addEdit');
  const MasterDeleteWrapper = createConditionalComponent(logInRights, 'masters', 'customAttribute', 'delete');
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'customAttribute', 'addEdit');

  const handleOpenLabelOption = (optionIndex) => {
    let data = cloneDeep(openList);

    if (data.includes(optionIndex)) {
      const indexOf = data.indexOf(optionIndex);
      if (indexOf > -1) {
        data.splice(indexOf, 1);
      }
    } else {
      data = [index, ...data];
    }
    setOpenList(data);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className="card mb-16 common-listing-card flex-fill" key={index}>
        <div className="card-body min-height-auto">
          <div className="dropdown-container">
            <div className="input-container">
              <div className="input-group form-floating-label fixed-label">
                <input
                  key={index}
                  name="freeLabel"
                  autoFocus={!item?._id}
                  value={item?.keyName ? item?.keyName : ''}
                  placeholder={t('DROP_DOWN_CARD.ENTER_LABEL')}
                  type="text"
                  onChange={(e) => handleChanged(e, index)}
                  className="form-control"
                  disabled={!MasterAddEditAccess}
                />
                <label htmlFor="text" className="text-bold f-16 asterisk-req">
                  {t('DROP_DOWN_CARD.LABEL')}
                  <span>*</span>
                </label>
              </div>
              {item?.isEmpty && (item?.keyName === null || item?.keyName === '') && (
                <label htmlFor="text" className="text-danger m-0 p-1">
                  {t('DROP_DOWN_CARD.LABEL_REQUIRED')}
                </label>
              )}
            </div>
            <div className="input-action d-flex">
              {item?._id !== '' && masterAddEditAccess && (
                <>
                  <MasterAddEditWrapper>
                    <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ACTIVE_INACTIVE')}>
                      <button
                        type="button"
                        className="btn p-0 custom-action mr-0"
                        onClick={() => activeInactiveClicked(item?._id)}
                        id={item?._id}
                        aria-label={item?.isActive ? 'Active' : 'Inactive'}
                      >
                        <span className={item?.isActive ? 'icon-active f-24' : 'icon-inactive f-24'} />
                      </button>
                    </CustomTooltip>
                  </MasterAddEditWrapper>

                  <MasterAddEditWrapper>
                    <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_VALUE')}>
                      <button
                        type="button"
                        className="btn custom-action p-0"
                        onClick={() => addValueForLabel(item?._id, index)}
                        id={item?._id}
                        aria-label="Add"
                      >
                        <span className="icon-Add f-24" />
                      </button>
                    </CustomTooltip>
                  </MasterAddEditWrapper>
                </>
              )}

              <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_OPTION')}>
                <button
                  type="button"
                  className="position-relative custom-action btn mr-0"
                  onClick={() => {
                    handleOpenLabelOption(index);
                  }}
                >
                  {openList.includes(index) ? (
                    <span className="icon-new-down-arrow-icon f-24 icon-dropdown icon-inverse" />
                  ) : (
                    <span className="icon-new-down-arrow-icon f-24 icon-dropdown" />
                  )}
                </button>
              </CustomTooltip>
              {masterDeleteAccess && (
                <MasterDeleteWrapper>
                  <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
                    <button
                      type="button"
                      className=" btn custom-action mr-0"
                      onClick={() => {
                        handleDelete(item?._id ? item?._id : index);
                      }}
                      aria-label="delete"
                    >
                      <span className="icon-Delete f-24" />
                    </button>
                  </CustomTooltip>
                </MasterDeleteWrapper>
              )}
            </div>
          </div>

          {!isEmpty(isUniqueId) && isUniqueId?.includes(index) && (
            <label htmlFor="text" className="text-danger m-0 p-1">
              {t('DROP_DOWN_CARD.ENTRY_EXIST')}
            </label>
          )}
          <div className="product-type-container mt-16 custom-multiselect ">
            <CommonMultiSelect
              label={t('DROP_DOWN_CARD.PRODUCT_TYPE')}
              required
              onChange={(e) => onDropSelectionChange(e, index)}
              selectedValue={item?.productType}
              optionList={(item?._id ? pcTypeList : pcTypeList?.filter((e) => e?.isActive) || [])?.map((e) => ({
                ...e,
                disabled:
                  item?._id &&
                  item?.isUsedProductType?.includes(e._id?.toString()) &&
                  item?.productType?.map((p) => p?.toString())?.includes(e._id?.toString()),
              }))}
              selectLabel="name"
              selectValue="_id"
              className="text-bold f-16"
            />
            {item?.isEmpty && item?.productType?.length === 0 && (
              <label htmlFor="text" className="text-danger m-0 p-1">
                {t('DROP_DOWN_CARD.PRODUCT_TYPE_REQUIRED')}
              </label>
            )}
          </div>
          {!isEmpty(item?.values || []) ? (
            item?.values?.map((eleValue, indexValue) => {
              return (
                <div key={eleValue?._id} className={openList.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
                  <div className="freetext-container mt-2 mx-0 d-flex">
                    <input
                      name="aliasName"
                      value={eleValue?.aliasName || ''}
                      maxLength={5}
                      onChange={(e) => handleValueChanged(e, indexValue, index)}
                      className="w-50px mr-2"
                      disabled={!masterAddEditAccess}
                    />
                    <div className="input-container">
                      <div className="input-group form-floating-label fixed-label">
                        <input
                          key={eleValue?._id}
                          name="freeLabel"
                          autoFocus={!eleValue._id}
                          disabled={!masterAddEditAccess}
                          value={eleValue.keyName ? eleValue.keyName : ''}
                          placeholder={t('DROP_DOWN_CARD.ENTER_VALUE')}
                          type="text"
                          onChange={(e) => handleValueChanged(e, indexValue, index)}
                          className="form-control"
                        />
                        <label htmlFor="text" className="asterisk-req">
                          {t('DROP_DOWN_CARD.VALUE')} {indexValue + 1}
                          <span>*</span>
                        </label>
                      </div>
                      {item?.isEmpty && (eleValue?.keyName === null || eleValue?.keyName === '') && (
                        <label htmlFor="text" className="text-danger m-0 p-1">
                          {t('DROP_DOWN_CARD.VALUE_REQUIRED')}
                        </label>
                      )}
                      {!isEmpty(uniqueValueId) && uniqueValueId?.includes(indexValue) && (
                        <label htmlFor="text" className="text-danger m-0 p-1">
                          {t('DROP_DOWN_CARD.ENTRY_EXIST')}
                        </label>
                      )}
                    </div>

                    <div className="input-action d-flex">
                      {eleValue._id !== '' && masterAddEditAccess && (
                        <MasterAddEditWrapper>
                          <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ACTIVE_INACTIVE')}>
                            <button
                              type="button"
                              className="btn p-0 custom-action mr-0"
                              aria-label="Active"
                              onClick={() => activeInactiveClicked(item?._id, eleValue._id)}
                              id={eleValue._id}
                            >
                              <span className={eleValue.isActive ? 'icon-active f-24' : 'icon-inactive f-24'} />
                            </button>
                          </CustomTooltip>
                        </MasterAddEditWrapper>
                      )}
                      {masterDeleteAccess && (
                        <MasterDeleteWrapper>
                          <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.DELETE')}>
                            <button
                              className="btn custom-action p-0 mr-0"
                              type="button"
                              aria-label="Delete"
                              onClick={() => {
                                handleDelete(eleValue._id ? eleValue._id : indexValue, index);
                              }}
                            >
                              <span className="icon-Delete f-24" />
                            </button>
                          </CustomTooltip>
                        </MasterDeleteWrapper>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className={openList?.includes(index) ? 'dropdown-items show' : 'dropdown-items '}>
              <p className="mt-3 mb-0 text-center">{t('DROP_DOWN_CARD.NO_OPTIONS_FOUND')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
